export const defaultErrorText = "This is required information";
export const AMEX_CODE = "37";
export const LBS_TO_GR_VALUE = 453.592;
export const FT_TO_INCHES_VALUE = 12;
export const INCH_TO_CENTIMETER_VALUE = 2.54;
